module.exports = __webpack_public_path__ + "img/clement4.18ecfe70.png";